document.addEventListener('DOMContentLoaded', function() {
  // Custom dropdown functionality
  const dropdowns = document.querySelectorAll('.custom-dropdown');
  
  dropdowns.forEach(dropdown => {
    const selected = dropdown.querySelector('.dropdown-selected');
    const options = dropdown.querySelectorAll('.dropdown-option');
    
    // Toggle dropdown on click
    dropdown.addEventListener('click', function(e) {
      e.stopPropagation();
      
      // Close all other dropdowns
      dropdowns.forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('active');
        }
      });
      
      // Toggle the clicked dropdown
      dropdown.classList.toggle('active');
    });
    
    // Handle option selection
    options.forEach(option => {
      option.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Update selected text and value
        selected.textContent = option.textContent;
        selected.setAttribute('data-value', option.getAttribute('data-value'));
        
        // Update selected state
        options.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        
        // Close dropdown
        dropdown.classList.remove('active');
        
        // Trigger custom event for form handling
        const changeEvent = new CustomEvent('dropdownChange', {
          detail: {
            value: option.getAttribute('data-value'),
            text: option.textContent,
            dropdown: dropdown.getAttribute('data-dropdown')
          }
        });
        dropdown.dispatchEvent(changeEvent);
      });
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function() {
    dropdowns.forEach(dropdown => {
      dropdown.classList.remove('active');
    });
  });

  // Handle recommendations finder button click
  const recommendationsButton = document.querySelector('.recommendations-finder-button');
  if (recommendationsButton) {
    recommendationsButton.addEventListener('click', function() {
      // Collect all dropdown values
      const recipient = document.querySelector('[data-dropdown="recipient"] .dropdown-selected').getAttribute('data-value');
      const expertise = document.querySelector('[data-dropdown="expertise"] .dropdown-selected').getAttribute('data-value');
      const method = document.querySelector('[data-dropdown="method"] .dropdown-selected').getAttribute('data-value');
      
      // Build the filtered collection URL using product tags
      // Format: filter.p.tag={tag_name}
      let collectionUrl = window.recommendationsFinderConfig?.collectionUrl || '/collections/all';
      const searchParams = new URLSearchParams();
      
      // Add filters based on dropdown selections using product tags
      if (recipient) {
        searchParams.append('filter.p.tag', `${recipient}`);
      }
      
      if (expertise) {
        searchParams.append('filter.p.tag', `${expertise}`);
      }
      
      if (method) {
        searchParams.append('filter.p.tag', `${method}`);
      }
      
      // Add search parameters to URL if any exist
      if (searchParams.toString()) {
        collectionUrl += '?' + searchParams.toString();
      }
      
      // Redirect to the filtered collection page
      window.location.href = collectionUrl;
    });
  }
});